<template>
  <div>
    <SelectInput
      label="Patient Name Order"
      v-model="settings.patientNameOrder"
      :items="patientNameOptions"
    />
    <SelectInput
      label="Patient Address On Report"
      v-model="settings.includePatientAddress"
      :items="booleanOptions"
    />
    <SelectInput
      label="Patient History On Report"
      v-model="settings.includePatientHistory"
      :items="booleanOptions"
    />
    <SelectInput label="ICD On Report" v-model="settings.includeICD" :items="booleanOptions" />
  </div>
</template>

<script>
import SelectInput from "./common/SelectInput.vue";

export default {
  components: { SelectInput },
  props: ["value"],
  data() {
    return {
      settings: {
        patientNameOrder: null,
        includePatientAddress: false,
        includePatientHistory: false,
        includeICD: false
      },
      patientNameOptions: [
        {
          id: 1,
          displayName: "First, Last"
        },
        {
          id: 2,
          displayName: "Last, First"
        }
      ],
      booleanOptions: [
        { displayName: "Yes", id: true },
        { displayName: "No", id: false }
      ]
    };
  },
  mounted() {
    if (this.value) {
      this.settings = { ...this.settings, ...JSON.parse(this.value) };
    }
  },
  watch: {
    settings: {
      immediate: true,
      deep: true,
      handler(nv) {
        this.$emit("changeJSON", JSON.stringify(nv));
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
